/**
 * IMPORTANT: This is a generated file. Do not edit it by hand.
 *
 * Run `pnpm run generate-http-endpoint` from the workspace root to regenerate it. CI regenerates it
 * too and fails if the result differs.
 *
 * Use HttpEndpoint ONLY for the `invalidates` and `removes` properties of an endpoint definition.
 * Anywhere else, name a route with RegisteredHttpEndpoint, which is derived from the registry and so
 * cannot go stale.
 *
 * Why the union is written out rather than derived: RegisteredHttpEndpoint is
 * `keyof typeof endpointRegistry`, and the registry holds the very endpoint definitions whose
 * `invalidates` would name it. Typing `invalidates` as RegisteredHttpEndpoint makes the registry's
 * type depend on itself, and TypeScript refuses that cycle instead of resolving it: `invalidates` is
 * "referenced directly or indirectly in its own type annotation" (TS2502), and the *Endpoints
 * objects that reach it fall back to `any` (TS7022), which erases the request and response types
 * of every route they hold. So the union is emitted from the registry's runtime keys instead, and
 * endpoint.test.ts asserts that the two types stay equivalent.
 */
export type HttpEndpoint =
    | 'DELETE /3rdparty/alelektronik/credentials'
    | 'DELETE /3rdparty/alfatec/credentials'
    | 'DELETE /3rdparty/arrow/credentials'
    | 'DELETE /3rdparty/atlantiknetworxx/credentials'
    | 'DELETE /3rdparty/avnetabacusv3/credentials'
    | 'DELETE /3rdparty/avnetebvv3/credentials'
    | 'DELETE /3rdparty/avnetsilicav3/credentials'
    | 'DELETE /3rdparty/avnetusav3/credentials'
    | 'DELETE /3rdparty/blume/credentials'
    | 'DELETE /3rdparty/bossard/credentials'
    | 'DELETE /3rdparty/buerklin/credentials'
    | 'DELETE /3rdparty/corestaff/credentials'
    | 'DELETE /3rdparty/digikey/delete-token'
    | 'DELETE /3rdparty/digikeyv4/credentials'
    | 'DELETE /3rdparty/ecomal/credentials'
    | 'DELETE /3rdparty/element14/credentials'
    | 'DELETE /3rdparty/eve/credentials'
    | 'DELETE /3rdparty/farnell/credentials'
    | 'DELETE /3rdparty/future/credentials'
    | 'DELETE /3rdparty/greenchips/credentials'
    | 'DELETE /3rdparty/gudeco/credentials'
    | 'DELETE /3rdparty/heilind/credentials'
    | 'DELETE /3rdparty/hexachip/credentials'
    | 'DELETE /3rdparty/ichub/credentials'
    | 'DELETE /3rdparty/ineltro/credentials'
    | 'DELETE /3rdparty/kruse/credentials'
    | 'DELETE /3rdparty/lcsc/credentials'
    | 'DELETE /3rdparty/lcscv3/credentials'
    | 'DELETE /3rdparty/master/credentials'
    | 'DELETE /3rdparty/mev/credentials'
    | 'DELETE /3rdparty/mouser/credentials'
    | 'DELETE /3rdparty/myarrow/credentials'
    | 'DELETE /3rdparty/newark/credentials'
    | 'DELETE /3rdparty/onlinecomponents/credentials'
    | 'DELETE /3rdparty/pcb-manufacturer/credentials/:manufacturerId'
    | 'DELETE /3rdparty/questcomponents/credentials'
    | 'DELETE /3rdparty/rapidelectronics/credentials'
    | 'DELETE /3rdparty/rmcomponents/credentials'
    | 'DELETE /3rdparty/rscomponents/credentials'
    | 'DELETE /3rdparty/rutronik/credentials'
    | 'DELETE /3rdparty/samtec/credentials'
    | 'DELETE /3rdparty/schukat/credentials'
    | 'DELETE /3rdparty/siliconexpert/credentials'
    | 'DELETE /3rdparty/sos-electronic/credentials'
    | 'DELETE /3rdparty/sourcengine/credentials'
    | 'DELETE /3rdparty/telcona/credentials'
    | 'DELETE /3rdparty/tistore/credentials'
    | 'DELETE /3rdparty/tme/credentials'
    | 'DELETE /3rdparty/trustedparts/credentials'
    | 'DELETE /3rdparty/tti/credentials'
    | 'DELETE /3rdparty/unikey/credentials'
    | 'DELETE /3rdparty/venkel/credentials'
    | 'DELETE /3rdparty/weltron/credentials'
    | 'DELETE /3rdparty/winsource/credentials'
    | 'DELETE /3rdparty/wittig/credentials'
    | 'DELETE /3rdparty/wuertheisos/credentials'
    | 'DELETE /activities/:activityId'
    | 'DELETE /activities/:activityId/overwrites'
    | 'DELETE /activity-configurations/bulk'
    | 'DELETE /additional-services/:additionalServiceId'
    | 'DELETE /alerts/stock-level/:id'
    | 'DELETE /approved-vendor-lists/:ruleId'
    | 'DELETE /assemblies/:assemblyId'
    | 'DELETE /assemblies/:assemblyId/delete/cad'
    | 'DELETE /assemblies/:assemblyId/delete/other'
    | 'DELETE /assemblies/:id/bom-design-items'
    | 'DELETE /assemblies/:id/pcb'
    | 'DELETE /calculations/frozen-scenario-cost/:frozenId'
    | 'DELETE /calculations/templates/:templateId'
    | 'DELETE /comments/:id'
    | 'DELETE /custom-attribute-definitions/bulk'
    | 'DELETE /custom-part-categories/bulk'
    | 'DELETE /custom-part-specification/:id'
    | 'DELETE /custom-part-specification/:id/custom-part/:customPartId'
    | 'DELETE /custom-part-specification/:id/files'
    | 'DELETE /custom-part-specification/:id/resources'
    | 'DELETE /customers/:customerId'
    | 'DELETE /dashboard/quick-actions/:id'
    | 'DELETE /demand-groups/:id'
    | 'DELETE /demand-scenarios/:demandScenarioId'
    | 'DELETE /email-template/:id'
    | 'DELETE /expense-configurations/bulk'
    | 'DELETE /expenses/:expenseId'
    | 'DELETE /export/bom/templates/:id'
    | 'DELETE /export/costed-bom/templates/:id'
    | 'DELETE /flexible-calculation/exported-variables/:id'
    | 'DELETE /flexible-calculation/kv/:key'
    | 'DELETE /flexible-calculation/plans/:id'
    | 'DELETE /flexible-calculation/templates/:id'
    | 'DELETE /internal-role-access'
    | 'DELETE /internal-roles/:roleId'
    | 'DELETE /machine-tokens/:id'
    | 'DELETE /manufacturers/:id/aliases/:aliasName'
    | 'DELETE /manufacturing-assembly-details/:assemblyDetailsId/assembly-wide-driver-count/:driverId'
    | 'DELETE /manufacturing-assembly-details/:manufacturingAssemblyDetailsId'
    | 'DELETE /manufacturing-kv-store/:key'
    | 'DELETE /manufacturing-scenario-template-instances/:manufacturingScenarioTemplateInstanceId'
    | 'DELETE /manufacturing-scenario-templates/:templateId'
    | 'DELETE /manufacturing-scenarios/:manufacturingScenarioId'
    | 'DELETE /negotiation-v2/:id'
    | 'DELETE /offer-import-contexts/:id'
    | 'DELETE /offers/:id'
    | 'DELETE /offers/custom-part/:id/additional-files'
    | 'DELETE /offers/off-the-shelf/:id/additional-files'
    | 'DELETE /order-management/order-selection-options'
    | 'DELETE /organization-settings/manufacturer-preferences/:partCategoryId/:status'
    | 'DELETE /organization-settings/sites/:siteId'
    | 'DELETE /panels/:panelId'
    | 'DELETE /pcb-panel-preferences/:preferenceId'
    | 'DELETE /pcb-pdf-specification-extraction/:pcbId'
    | 'DELETE /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId'
    | 'DELETE /pcb-specification-templates/:id'
    | 'DELETE /pcb/:pcbId/files'
    | 'DELETE /pnp/file'
    | 'DELETE /purchase-orders/delete'
    | 'DELETE /quotation-templates/:id'
    | 'DELETE /quotation/quotationitems/:item'
    | 'DELETE /quotation/quotations/:customer/quotations/:quotation/items/:item'
    | 'DELETE /quotation/quotations/quotations/:idOrName'
    | 'DELETE /quote-request/:id'
    | 'DELETE /quote-request/:id/additional-files'
    | 'DELETE /quote-request/:id/offers'
    | 'DELETE /quote-request/delete-many'
    | 'DELETE /quote-request/line-item/delete-offer'
    | 'DELETE /quote-request/template/:id'
    | 'DELETE /resources/:resourceId'
    | 'DELETE /rfqs/:rfqId'
    | 'DELETE /rfqs/:rfqId/quotation-builder-state'
    | 'DELETE /rfqs/:rfqId/quotation'
    | 'DELETE /siliconexpert/acl'
    | 'DELETE /sourcing-apis/:sourcesApi/relevance'
    | 'DELETE /sourcing-scenarios/:sourcingScenarioId'
    | 'DELETE /sourcing-templates/:id'
    | 'DELETE /supplier-contacts/:supplierContactId'
    | 'DELETE /supplier-terms/:supplierTermsId'
    | 'DELETE /suppliers/:id'
    | 'DELETE /user-drivers/:driverId'
    | 'DELETE /users/:userId'
    | 'DELETE /users/invites/:inviteId'
    | 'DELETE /users/organization/support-user'
    | 'GET /3rdparty/alelektronik/credentials'
    | 'GET /3rdparty/alfatec/credentials'
    | 'GET /3rdparty/arrow/credentials'
    | 'GET /3rdparty/arrow/supported-currencies'
    | 'GET /3rdparty/atlantiknetworxx/credentials'
    | 'GET /3rdparty/avnetabacusv3/credentials'
    | 'GET /3rdparty/avnetebvv3/credentials'
    | 'GET /3rdparty/avnetsilicav3/credentials'
    | 'GET /3rdparty/avnetusav3/credentials'
    | 'GET /3rdparty/blume/credentials'
    | 'GET /3rdparty/bossard/credentials'
    | 'GET /3rdparty/buerklin/credentials'
    | 'GET /3rdparty/corestaff/credentials'
    | 'GET /3rdparty/digikey/acquire-access-token-from-code'
    | 'GET /3rdparty/digikey/auth-redirect-uri'
    | 'GET /3rdparty/digikey/is-authenticated'
    | 'GET /3rdparty/digikey/settings'
    | 'GET /3rdparty/digikey/store-locations'
    | 'GET /3rdparty/digikeyv4/credentials'
    | 'GET /3rdparty/ecomal/credentials'
    | 'GET /3rdparty/element14/credentials'
    | 'GET /3rdparty/element14/supported-store-location-settings'
    | 'GET /3rdparty/eve/credentials'
    | 'GET /3rdparty/farnell/credentials'
    | 'GET /3rdparty/farnell/supported-store-location-settings'
    | 'GET /3rdparty/future/credentials'
    | 'GET /3rdparty/greenchips/credentials'
    | 'GET /3rdparty/gudeco/credentials'
    | 'GET /3rdparty/heilind/credentials'
    | 'GET /3rdparty/hexachip/credentials'
    | 'GET /3rdparty/ichub/credentials'
    | 'GET /3rdparty/ineltro/credentials'
    | 'GET /3rdparty/kruse/credentials'
    | 'GET /3rdparty/lcsc/credentials'
    | 'GET /3rdparty/lcscv3/credentials'
    | 'GET /3rdparty/master/credentials'
    | 'GET /3rdparty/mev/credentials'
    | 'GET /3rdparty/mouser/credentials'
    | 'GET /3rdparty/myarrow/credentials'
    | 'GET /3rdparty/myarrow/supported-currencies'
    | 'GET /3rdparty/newark/credentials'
    | 'GET /3rdparty/newark/supported-store-location-settings'
    | 'GET /3rdparty/onlinecomponents/credentials'
    | 'GET /3rdparty/pcb-manufacturer/credentials/:manufacturerId'
    | 'GET /3rdparty/questcomponents/credentials'
    | 'GET /3rdparty/rapidelectronics/credentials'
    | 'GET /3rdparty/rmcomponents/credentials'
    | 'GET /3rdparty/rochester/credentials'
    | 'GET /3rdparty/rscomponents/credentials'
    | 'GET /3rdparty/rscomponents/supported-country-code'
    | 'GET /3rdparty/rscomponents/supported-store-id'
    | 'GET /3rdparty/rutronik/credentials'
    | 'GET /3rdparty/samtec/credentials'
    | 'GET /3rdparty/schukat/credentials'
    | 'GET /3rdparty/siliconexpert/credentials'
    | 'GET /3rdparty/siliconexpert/quota'
    | 'GET /3rdparty/sos-electronic/credentials'
    | 'GET /3rdparty/sourcengine/credentials'
    | 'GET /3rdparty/telcona/credentials'
    | 'GET /3rdparty/tistore/credentials'
    | 'GET /3rdparty/tistore/supported-currencies'
    | 'GET /3rdparty/tme/credentials'
    | 'GET /3rdparty/trustedparts/credentials'
    | 'GET /3rdparty/trustedparts/supported-locale-settings'
    | 'GET /3rdparty/tti/credentials'
    | 'GET /3rdparty/unikey/credentials'
    | 'GET /3rdparty/venkel/credentials'
    | 'GET /3rdparty/weltron/credentials'
    | 'GET /3rdparty/winsource/credentials'
    | 'GET /3rdparty/wittig/credentials'
    | 'GET /3rdparty/wuertheisos/credentials'
    | 'GET /action-permission-map'
    | 'GET /activities'
    | 'GET /activities/:activityId'
    | 'GET /activities/:activityId/overwrites'
    | 'GET /additional-services'
    | 'GET /alerts/stock-level'
    | 'GET /alerts/stock-level/:id'
    | 'GET /approved-vendor-lists'
    | 'GET /approved-vendor-lists/suppliers/:supplierId'
    | 'GET /assemblies/:assemblyId/aggregate-quantity'
    | 'GET /assemblies/:assemblyId/assembly-descendants'
    | 'GET /assemblies/:assemblyId/bom-files'
    | 'GET /assemblies/:assemblyId/commentators'
    | 'GET /assemblies/:assemblyId/data'
    | 'GET /assemblies/:assemblyId/descendants-summary'
    | 'GET /assemblies/:assemblyId/descendants'
    | 'GET /assemblies/:assemblyId/monitoring'
    | 'GET /assemblies/:assemblyId/parents'
    | 'GET /assemblies/:assemblyId/pcb/:pcbId/emissions'
    | 'GET /assemblies/:assemblyId/resources'
    | 'GET /assemblies/:assemblyId/state'
    | 'GET /assemblies/:assemblyId/tree'
    | 'GET /assemblies/:assemblyId/upload/cad'
    | 'GET /assemblies/:assemblyId/upload/other'
    | 'GET /assemblies/:id/bom-file/resources'
    | 'GET /assemblies/:id/descendants-ots-part-ids'
    | 'GET /assemblies/:id/descendants-part-ids-without-emission-data'
    | 'GET /assemblies/:id/history'
    | 'GET /assemblies/health-summary'
    | 'GET /assembly/assemblies/:assembly/lifecycles'
    | 'GET /assembly/assemblies/:assembly/versions/:version/files/:file/lifecycles'
    | 'GET /assembly/assemblies/:assembly/versions/:version/files/:file/lifecycles/:lcname'
    | 'GET /assembly/assemblies/:assembly/versions/:version/lifecycles'
    | 'GET /assembly/assemblies/:assembly/versions/:version/lifecycles/:lcname'
    | 'GET /assembly/assemblies/:assembly/versions/:version/lifecyclesummary'
    | 'GET /assembly/shares/:share'
    | 'GET /azure-erp-files'
    | 'GET /bom-files/:bomFileId/upload'
    | 'GET /bom-files/examples'
    | 'GET /bom-files/upload-failed'
    | 'GET /bom-importer/line-builder/tasks/:taskId'
    | 'GET /bom-importer/screener/tasks/:taskId'
    | 'GET /bom-items/:aggregationKey'
    | 'GET /bom-items/:aggregationKey/suggestions'
    | 'GET /calculations/calculation-assembly-costs'
    | 'GET /calculations/calculation-assembly-costs/export-pdf-data'
    | 'GET /calculations/calculation-assembly-details'
    | 'GET /calculations/scenario-combinations'
    | 'GET /calculations/templates'
    | 'GET /calculations/templates/:templateId'
    | 'GET /components/custom/:componentId'
    | 'GET /components/health-summary'
    | 'GET /components/last-import'
    | 'GET /contributors/rfqs/:rfqId'
    | 'GET /custom-attribute-definitions/:entityType'
    | 'GET /custom-part-alerts/:partId'
    | 'GET /custom-part-categories'
    | 'GET /custom-part-categories/:id'
    | 'GET /custom-part-specification/:id'
    | 'GET /custom-part-specification/:id/custom-part'
    | 'GET /custom-part-specification/:id/resources'
    | 'GET /custom-part-specification/:id/upload'
    | 'GET /custom-part/:id'
    | 'GET /customer-portal-settings'
    | 'GET /customer-portal-settings/customer-specific-settings/aggregate'
    | 'GET /customer-portal-settings/payment-settings'
    | 'GET /customers'
    | 'GET /customers/:customerId'
    | 'GET /dashboard/preferences'
    | 'GET /dashboard/quick-actions'
    | 'GET /demand-groups/:id'
    | 'GET /demand'
    | 'GET /design-items/:designItemId/part-alternatives'
    | 'GET /email-template'
    | 'GET /emissions/pcb/:pcbId'
    | 'GET /ems/pcb/:assembly/versions/:version/drills'
    | 'GET /ems/pcb/:assembly/versions/:version/outline'
    | 'GET /ems/pcb/:assembly/versions/:version/outlines'
    | 'GET /ems/pcb/v2/pcbs/:pcb/journal'
    | 'GET /ems/pcb/v2/pcbs/:pcb/journal/events/:entityType/:entityId/:seq'
    | 'GET /ems/pcb/v2/pcbs/:pcb/specifications'
    | 'GET /ems/pcb/v2/pcbs/:pcb/specifications/:specification'
    | 'GET /ems/pcb/v2/pcbs/:pcbId'
    | 'GET /ems/pcb/v2/pcbs/:pcbId/capabilities'
    | 'GET /ems/pcb/v2/pcbs/:pcbId/files/all'
    | 'GET /ems/pcb/v2/pcbs/:pcbId/files/singular/:fileName'
    | 'GET /ems/pcb/v2/pcbs/:pcbId/token'
    | 'GET /ems/pcb/v2/shares/:share'
    | 'GET /ems/pcb/v2/shares/:share/capabilities'
    | 'GET /ems/pcb/v2/shares/:share/files/all'
    | 'GET /ems/pcb/v2/shares/:share/outline'
    | 'GET /ems/pcb/v2/shares/:share/outlines'
    | 'GET /ems/pcb/v2/shares/:share/specifications'
    | 'GET /ems/pcb/v2/shares/:share/specifications/:specification'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:pcbId/files/:fileName'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:versionId/annularRings'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:versionId/distances'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:versionId/files/:fileName/distances'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:versionId/files/:fileName/tracewidths'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:versionId/files/graphics'
    | 'GET /ems/renderer/assemblies/:assemblyId/versions/:versionId/tracewidths'
    | 'GET /ems/renderer/layerstacks/versions/:pcbId'
    | 'GET /expenses'
    | 'GET /expenses/:expenseId'
    | 'GET /export/assembly-bom-xlsx'
    | 'GET /export/bom-xlsx'
    | 'GET /export/bom/templates'
    | 'GET /export/calculation-cost-xlsx'
    | 'GET /export/costed-bom-xlsx'
    | 'GET /export/costed-bom/templates'
    | 'GET /export/manufacturing-xlsx'
    | 'GET /feature-flags/:featureFlag/tenants'
    | 'GET /files/download/:filePath'
    | 'GET /flexible-calculation/exported-variables'
    | 'GET /flexible-calculation/exported-variables/:id'
    | 'GET /flexible-calculation/kv/:key'
    | 'GET /flexible-calculation/plans/:id'
    | 'GET /flexible-calculation/plans/:id/export'
    | 'GET /flexible-calculation/plans/rfq/:rfqId'
    | 'GET /flexible-calculation/templates'
    | 'GET /flexible-calculation/templates/:id'
    | 'GET /gateway/llm/quotation-template/references'
    | 'GET /gateway/llm/quotation-template/references/:id'
    | 'GET /internal-role-access'
    | 'GET /internal-roles'
    | 'GET /internal-user-role-memberships'
    | 'GET /landing-page-tiles'
    | 'GET /machine-tokens'
    | 'GET /machine-tokens/available-roles'
    | 'GET /manufacturers'
    | 'GET /manufacturers/:id/line-card'
    | 'GET /manufacturers/line-card'
    | 'GET /manufacturing-assembly-details'
    | 'GET /manufacturing-assembly-details/:duplicateRouteHackAskChrisAssemblyDetailsId'
    | 'GET /manufacturing-assembly-details/:manufacturingAssemblyDetailsId'
    | 'GET /manufacturing-assembly-details/:manufacturingAssemblyDetailsId/manufacturing-scenarios'
    | 'GET /manufacturing-assembly-details/:manufacturingAssemblyDetailsId/overview'
    | 'GET /manufacturing-cache/sourcing/last_refresh/:assemblyId'
    | 'GET /manufacturing-kv-store'
    | 'GET /manufacturing-kv-store/:key'
    | 'GET /manufacturing-scenario-templates'
    | 'GET /manufacturing-scenario-templates/:templateId'
    | 'GET /manufacturing-scenarios'
    | 'GET /manufacturing-scenarios/:manufacturingScenarioId'
    | 'GET /manufacturing-scenarios/:manufacturingScenarioId/full-summary'
    | 'GET /my/details'
    | 'GET /my/feature-flags'
    | 'GET /my/intercom'
    | 'GET /my/magicbell'
    | 'GET /my/permissions'
    | 'GET /my/settings/account-security'
    | 'GET /my/version'
    | 'GET /negotiation-v2'
    | 'GET /negotiation-v2/:id'
    | 'GET /offer-import-contexts'
    | 'GET /offer-import-contexts/:id'
    | 'GET /offers/custom-part'
    | 'GET /offers/custom-part/:id'
    | 'GET /offers/custom-part/:id/additional-files'
    | 'GET /offers/custom-part/:id/additional-files/upload-link'
    | 'GET /offers/custom-part/:id/download-order-files'
    | 'GET /offers/off-the-shelf/:id/additional-files'
    | 'GET /offers/off-the-shelf/:id/additional-files/upload-link'
    | 'GET /offers/off-the-shelf/:id/affiliate-url'
    | 'GET /offers/off-the-shelf/by-ipn'
    | 'GET /order-management/order-selection-options'
    | 'GET /order-management/orders'
    | 'GET /organization-settings/auto-rfq-number/next'
    | 'GET /organization-settings/checkout-conditions'
    | 'GET /organization-settings/default-pcb-panel-preferences'
    | 'GET /organization-settings/feature-flags/config'
    | 'GET /organization-settings/landing-page-settings'
    | 'GET /organization-settings/landing-page-tiles'
    | 'GET /organization-settings/manufacturer-preferences'
    | 'GET /organization-settings/organization-currency-settings'
    | 'GET /organization-settings/payments/credentials'
    | 'GET /organization-settings/pcb-api-settings'
    | 'GET /organization-settings/self-signup'
    | 'GET /organization-settings/sites'
    | 'GET /organization-settings/webhooks/dashboard-url'
    | 'GET /organization/emission-request-quota'
    | 'GET /organization/settings'
    | 'GET /panels'
    | 'GET /parts/custom-types'
    | 'GET /parts/library/health-summary'
    | 'GET /parts/library/indexing-status'
    | 'GET /parts/library/search/progress/:taskId'
    | 'GET /parts/off-the-shelf-types'
    | 'GET /parts/off-the-shelf/:partId/votes'
    | 'GET /parts/package-families'
    | 'GET /parts/packages'
    | 'GET /parts/part-categories'
    | 'GET /pcb-approval-state'
    | 'GET /pcb-panel-preferences'
    | 'GET /pcb-pdf-specification-extraction'
    | 'GET /pcb-sides'
    | 'GET /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId'
    | 'GET /pcb-specification-templates'
    | 'GET /pcb-specification-templates/:id'
    | 'GET /pcb/:pcbId/graphics'
    | 'GET /pcb/:pcbId/panel/download-pdf'
    | 'GET /pnp'
    | 'GET /pnp/bulk/view'
    | 'GET /pnp/file'
    | 'GET /price/calculation'
    | 'GET /price/calculation/:nameOrID'
    | 'GET /price/calculation/:nameOrID/export'
    | 'GET /price/calculation/:nameOrID/tables/:table'
    | 'GET /price/calculation/:nameOrID/tables/:table/versions/:version'
    | 'GET /price/calculation/:nameOrID/variables'
    | 'GET /price/capabilities'
    | 'GET /price/capabilities/:supplier'
    | 'GET /public-exchange-rate'
    | 'GET /purchase-orders/:rfqId'
    | 'GET /purchase-orders/excel/:purchaseOrderId'
    | 'GET /quotation-templates'
    | 'GET /quotation-templates/:id'
    | 'GET /quotation/quotationitems'
    | 'GET /quotation/quotationitems/:item'
    | 'GET /quotation/quotations'
    | 'GET /quotation/quotations/:idOrName'
    | 'GET /quotation/quotations/:idOrName/print'
    | 'GET /quotation/quotations/all'
    | 'GET /quotation/quotations/export/csv'
    | 'GET /quotation/search'
    | 'GET /quote-request/:id'
    | 'GET /quote-request/:id/additional-files'
    | 'GET /quote-request/:id/additional-files/upload-link'
    | 'GET /quote-request/:id/commentators'
    | 'GET /quote-request/:id/download-excel'
    | 'GET /quote-request/:id/email-logs'
    | 'GET /quote-request/:id/line-items'
    | 'GET /quote-request/:id/offers'
    | 'GET /quote-request/has-unapproved-pcb'
    | 'GET /quote-request/template'
    | 'GET /quote-request/template/:id'
    | 'GET /resources'
    | 'GET /resources/:resourceId'
    | 'GET /rfqs'
    | 'GET /rfqs/:rfqId'
    | 'GET /rfqs/:rfqId/additional-services'
    | 'GET /rfqs/:rfqId/demands'
    | 'GET /rfqs/:rfqId/possible-contributors'
    | 'GET /rfqs/:rfqId/project-progress'
    | 'GET /rfqs/:rfqId/quotation-builder-data'
    | 'GET /rfqs/:rfqId/quotation-builder-state'
    | 'GET /rfqs/:rfqId/quotation'
    | 'GET /rfqs/:rfqId/quotation/upload'
    | 'GET /rfqs/:rfqId/quotation/warnings'
    | 'GET /rfqs/:rfqId/snapshot'
    | 'GET /rfqs/:rfqId/snapshot/:snapshotId/costed-bom-xlsx'
    | 'GET /rfqs/project-progress'
    | 'GET /rfqs/project-progress/history'
    | 'GET /rfqs/status-history'
    | 'GET /risk-management/geo-risks'
    | 'GET /risk-management/notifications'
    | 'GET /risk-management/risk-digest'
    | 'GET /risk-management/top-affected-assemblies'
    | 'GET /siliconexpert/acl'
    | 'GET /siliconexpert/authorized-parts'
    | 'GET /siliconexpert/authorized-parts/details'
    | 'GET /siliconexpert/pcn'
    | 'GET /siliconexpert/raw'
    | 'GET /sourcing-apis/relevance'
    | 'GET /sourcing-line-item/:id'
    | 'GET /sourcing-line-item/:id/solutions'
    | 'GET /sourcing-templates'
    | 'GET /sourcing-templates/:id'
    | 'GET /sourcing/calculation/line-items/:id'
    | 'GET /sourcing/export/supplier-award-files'
    | 'GET /sourcing/progress/:rfqId'
    | 'GET /supplier-contacts'
    | 'GET /supplier/:supplierId/terms'
    | 'GET /suppliers-and-stock-locations'
    | 'GET /suppliers'
    | 'GET /suppliers/:id'
    | 'GET /suppliers/:id/line-card-rules'
    | 'GET /suppliers/:id/line-card'
    | 'GET /suppliers/:supplierId/supplier-contacts'
    | 'GET /suppliers/line-card-rules'
    | 'GET /suppliers/line-card'
    | 'GET /tenant/details'
    | 'GET /user-drivers'
    | 'GET /user-drivers/:driverId'
    | 'GET /users/:userId'
    | 'GET /users/:userId/roles'
    | 'GET /users/customers/:customerId'
    | 'GET /users/customers/:customerId/invites'
    | 'GET /users/organization'
    | 'GET /users/organization/invites'
    | 'PATCH /3rdparty/alelektronik/credentials'
    | 'PATCH /3rdparty/alfatec/credentials'
    | 'PATCH /3rdparty/arrow/credentials'
    | 'PATCH /3rdparty/atlantiknetworxx/credentials'
    | 'PATCH /3rdparty/avnetabacusv3/credentials'
    | 'PATCH /3rdparty/avnetebvv3/credentials'
    | 'PATCH /3rdparty/avnetsilicav3/credentials'
    | 'PATCH /3rdparty/avnetusav3/credentials'
    | 'PATCH /3rdparty/blume/credentials'
    | 'PATCH /3rdparty/bossard/credentials'
    | 'PATCH /3rdparty/buerklin/credentials'
    | 'PATCH /3rdparty/corestaff/credentials'
    | 'PATCH /3rdparty/digikey/settings'
    | 'PATCH /3rdparty/digikeyv4/credentials'
    | 'PATCH /3rdparty/ecomal/credentials'
    | 'PATCH /3rdparty/element14/credentials'
    | 'PATCH /3rdparty/eve/credentials'
    | 'PATCH /3rdparty/farnell/credentials'
    | 'PATCH /3rdparty/future/credentials'
    | 'PATCH /3rdparty/greenchips/credentials'
    | 'PATCH /3rdparty/gudeco/credentials'
    | 'PATCH /3rdparty/heilind/credentials'
    | 'PATCH /3rdparty/hexachip/credentials'
    | 'PATCH /3rdparty/ichub/credentials'
    | 'PATCH /3rdparty/ineltro/credentials'
    | 'PATCH /3rdparty/kruse/credentials'
    | 'PATCH /3rdparty/lcsc/credentials'
    | 'PATCH /3rdparty/lcscv3/credentials'
    | 'PATCH /3rdparty/master/credentials'
    | 'PATCH /3rdparty/mev/credentials'
    | 'PATCH /3rdparty/mouser/credentials'
    | 'PATCH /3rdparty/myarrow/credentials'
    | 'PATCH /3rdparty/newark/credentials'
    | 'PATCH /3rdparty/onlinecomponents/credentials'
    | 'PATCH /3rdparty/pcb-manufacturer/credentials/:manufacturerId'
    | 'PATCH /3rdparty/questcomponents/credentials'
    | 'PATCH /3rdparty/rapidelectronics/credentials'
    | 'PATCH /3rdparty/rmcomponents/credentials'
    | 'PATCH /3rdparty/rochester/credentials'
    | 'PATCH /3rdparty/rscomponents/credentials'
    | 'PATCH /3rdparty/rutronik/credentials'
    | 'PATCH /3rdparty/samtec/credentials'
    | 'PATCH /3rdparty/schukat/credentials'
    | 'PATCH /3rdparty/siliconexpert/credentials'
    | 'PATCH /3rdparty/sos-electronic/credentials'
    | 'PATCH /3rdparty/sourcengine/credentials'
    | 'PATCH /3rdparty/telcona/credentials'
    | 'PATCH /3rdparty/tistore/credentials'
    | 'PATCH /3rdparty/tme/credentials'
    | 'PATCH /3rdparty/trustedparts/credentials'
    | 'PATCH /3rdparty/tti/credentials'
    | 'PATCH /3rdparty/unikey/credentials'
    | 'PATCH /3rdparty/venkel/credentials'
    | 'PATCH /3rdparty/weltron/credentials'
    | 'PATCH /3rdparty/winsource/credentials'
    | 'PATCH /3rdparty/wittig/credentials'
    | 'PATCH /3rdparty/wuertheisos/credentials'
    | 'PATCH /activities/:activityId'
    | 'PATCH /activities/:activityId/overwrites/:activityOverwriteId'
    | 'PATCH /activity-configurations/:activityConfigurationId'
    | 'PATCH /activity-configurations/:activityConfigurationId/notes'
    | 'PATCH /activity-configurations/:activityConfigurationId/rank'
    | 'PATCH /additional-services/:additionalServiceId'
    | 'PATCH /alerts/stock-level/:id'
    | 'PATCH /approved-vendor-lists/suppliers/:supplierId'
    | 'PATCH /assemblies/:assemblyId'
    | 'PATCH /bom-items/:aggregationKey'
    | 'PATCH /calculations/calculation-assembly-costs/:calculationAssemblyCostId'
    | 'PATCH /calculations/calculation-assembly-details/:calculationAssemblyDetailsId'
    | 'PATCH /calculations/calculation-assembly-details/:calculationAssemblyDetailsId/reset'
    | 'PATCH /calculations/scenario-combinations'
    | 'PATCH /calculations/templates/:templateId'
    | 'PATCH /comments/:id'
    | 'PATCH /components/:ipn/specifications/matches'
    | 'PATCH /components/custom/:componentId'
    | 'PATCH /contributors/rfqs/:rfqId'
    | 'PATCH /custom-attributes/:entityType/bulk'
    | 'PATCH /custom-part-categories/:id'
    | 'PATCH /custom-part-specification/:id'
    | 'PATCH /custom-part-specification/:id/custom-part/:customPartId'
    | 'PATCH /customer-portal-settings'
    | 'PATCH /customer-portal-settings/customer-specific-settings/aggregate'
    | 'PATCH /customers/:customerId'
    | 'PATCH /customers/:customerId/billing-address'
    | 'PATCH /dashboard/quick-actions/:id'
    | 'PATCH /demand-groups/:id'
    | 'PATCH /demand-scenarios/:demandScenarioId'
    | 'PATCH /email-template/:id'
    | 'PATCH /expense-configurations/:expenseConfigurationId'
    | 'PATCH /expense-configurations/:expenseConfigurationId/notes'
    | 'PATCH /expense-configurations/:expenseConfigurationId/rank'
    | 'PATCH /expenses/:expenseId'
    | 'PATCH /flexible-calculation/exported-variables/:id'
    | 'PATCH /flexible-calculation/kv/:key'
    | 'PATCH /flexible-calculation/plans/:id'
    | 'PATCH /flexible-calculation/plans/:id/approve-and-freeze'
    | 'PATCH /flexible-calculation/templates/:id'
    | 'PATCH /internal-roles'
    | 'PATCH /internal-user-role-memberships'
    | 'PATCH /ipns/:id'
    | 'PATCH /ipns/:id/form-and-fit'
    | 'PATCH /ipns/matches'
    | 'PATCH /machine-tokens/:id'
    | 'PATCH /manufacturers/:id'
    | 'PATCH /manufacturing-assembly-details/:assemblyDetailsId/assembly-wide-driver-count/:driverId'
    | 'PATCH /manufacturing-assembly-details/:assemblyDetailsId/assembly-wide-driver-count/:driverId/sourcing-scenarios'
    | 'PATCH /manufacturing-assembly-details/:manufacturingAssemblyDetailsId'
    | 'PATCH /manufacturing-kv-store/:key'
    | 'PATCH /manufacturing-scenario-template-instances/:manufacturingScenarioTemplateInstanceId/rank'
    | 'PATCH /manufacturing-scenario-templates/:templateId'
    | 'PATCH /manufacturing-scenarios/:manufacturingScenarioId'
    | 'PATCH /manufacturing-scenarios/:manufacturingScenarioId/append'
    | 'PATCH /manufacturing-scenarios/customer-portal/update-batch-size-from-sourcing-scenarios-order-size'
    | 'PATCH /my/settings/account-security'
    | 'PATCH /my/user'
    | 'PATCH /negotiation-v2/:id'
    | 'PATCH /offer-import-contexts/:id'
    | 'PATCH /offers/custom-part/:id'
    | 'PATCH /offers/custom-part/:id/copy-panel-from-design'
    | 'PATCH /offers/off-the-shelf/:id'
    | 'PATCH /organization-settings/feature-flags'
    | 'PATCH /organization-settings/feature-flags/user-overrides'
    | 'PATCH /organization-settings/landing-page-settings'
    | 'PATCH /organization-settings/manufacturer-preferences/:id/:status'
    | 'PATCH /organization-settings/organization-currency-settings'
    | 'PATCH /organization-settings/payments/credentials'
    | 'PATCH /organization-settings/pcb-api-settings'
    | 'PATCH /organization-settings/self-signup'
    | 'PATCH /organization-settings/sites/:siteId'
    | 'PATCH /organization/settings'
    | 'PATCH /panels/:panelId'
    | 'PATCH /parts/off-the-shelf/:partId'
    | 'PATCH /pcb-approval-state/:pcbId'
    | 'PATCH /pcb-panel-preferences/:panelPreferenceId'
    | 'PATCH /pcb-sides'
    | 'PATCH /pcb-specification-templates/:id'
    | 'PATCH /purchase-orders/update'
    | 'PATCH /quotation-templates/:id'
    | 'PATCH /quote-request/:id'
    | 'PATCH /quote-request/template/:id'
    | 'PATCH /resources/:resourceId'
    | 'PATCH /rfqs/:rfqId'
    | 'PATCH /rfqs/:rfqId/archive'
    | 'PATCH /rfqs/:rfqId/project-progress'
    | 'PATCH /rfqs/:rfqId/request-quotation'
    | 'PATCH /rfqs/:rfqId/snapshot/:snapshotId'
    | 'PATCH /rfqs/:rfqId/unarchive'
    | 'PATCH /risk-management/notifications'
    | 'PATCH /sourcing-line-item'
    | 'PATCH /sourcing-line-item/:id'
    | 'PATCH /sourcing-scenarios/:sourcingScenarioId'
    | 'PATCH /sourcing-scenarios/:sourcingScenarioId/base'
    | 'PATCH /sourcing-templates/:id'
    | 'PATCH /supplier-contacts/:supplierContactId'
    | 'PATCH /supplier-contacts/upsert'
    | 'PATCH /supplier-terms/:supplierTermsId'
    | 'PATCH /suppliers-and-stock-locations/:id'
    | 'PATCH /suppliers/:id/line-card-rules'
    | 'PATCH /suppliers/:id/line-card'
    | 'PATCH /suppliers/:id/reset-line-card'
    | 'PATCH /user-drivers'
    | 'PATCH /user-drivers/:driverId'
    | 'PATCH /users/:userId'
    | 'PATCH /users/:userId/roles'
    | 'PATCH /users/invites/:inviteId/internal-role'
    | 'POST /3rdparty/alelektronik/credentials'
    | 'POST /3rdparty/alfatec/credentials'
    | 'POST /3rdparty/arrow/credentials'
    | 'POST /3rdparty/atlantiknetworxx/credentials'
    | 'POST /3rdparty/avnetabacusv3/credentials'
    | 'POST /3rdparty/avnetebvv3/credentials'
    | 'POST /3rdparty/avnetsilicav3/credentials'
    | 'POST /3rdparty/avnetusav3/credentials'
    | 'POST /3rdparty/blume/credentials'
    | 'POST /3rdparty/bossard/credentials'
    | 'POST /3rdparty/buerklin/credentials'
    | 'POST /3rdparty/corestaff/credentials'
    | 'POST /3rdparty/digikeyv4/credentials'
    | 'POST /3rdparty/ecomal/credentials'
    | 'POST /3rdparty/element14/credentials'
    | 'POST /3rdparty/eve/credentials'
    | 'POST /3rdparty/farnell/credentials'
    | 'POST /3rdparty/future/credentials'
    | 'POST /3rdparty/greenchips/credentials'
    | 'POST /3rdparty/gudeco/credentials'
    | 'POST /3rdparty/heilind/credentials'
    | 'POST /3rdparty/hexachip/credentials'
    | 'POST /3rdparty/ichub/credentials'
    | 'POST /3rdparty/ineltro/credentials'
    | 'POST /3rdparty/kruse/credentials'
    | 'POST /3rdparty/lcsc/credentials'
    | 'POST /3rdparty/lcscv3/credentials'
    | 'POST /3rdparty/master/credentials'
    | 'POST /3rdparty/mev/credentials'
    | 'POST /3rdparty/mouser/credentials'
    | 'POST /3rdparty/myarrow/credentials'
    | 'POST /3rdparty/newark/credentials'
    | 'POST /3rdparty/onlinecomponents/credentials'
    | 'POST /3rdparty/pcb-manufacturer/credentials/:manufacturerId'
    | 'POST /3rdparty/questcomponents/credentials'
    | 'POST /3rdparty/rapidelectronics/credentials'
    | 'POST /3rdparty/rmcomponents/credentials'
    | 'POST /3rdparty/rochester/credentials'
    | 'POST /3rdparty/rscomponents/credentials'
    | 'POST /3rdparty/rutronik/credentials'
    | 'POST /3rdparty/samtec/credentials'
    | 'POST /3rdparty/schukat/credentials'
    | 'POST /3rdparty/siliconexpert/credentials'
    | 'POST /3rdparty/siliconexpert/enrich'
    | 'POST /3rdparty/sos-electronic/credentials'
    | 'POST /3rdparty/sourcengine/credentials'
    | 'POST /3rdparty/telcona/credentials'
    | 'POST /3rdparty/tistore/credentials'
    | 'POST /3rdparty/tme/credentials'
    | 'POST /3rdparty/trustedparts/credentials'
    | 'POST /3rdparty/tti/credentials'
    | 'POST /3rdparty/unikey/credentials'
    | 'POST /3rdparty/venkel/credentials'
    | 'POST /3rdparty/weltron/credentials'
    | 'POST /3rdparty/winsource/credentials'
    | 'POST /3rdparty/wittig/credentials'
    | 'POST /3rdparty/wuertheisos/credentials'
    | 'POST /activities'
    | 'POST /activities/:activityId/overwrites'
    | 'POST /activity-configurations/bulk'
    | 'POST /additional-services'
    | 'POST /additional-services/bulk'
    | 'POST /alerts/stock-level'
    | 'POST /analyze/pdf'
    | 'POST /assemblies'
    | 'POST /assemblies/:assemblyId/monitoring'
    | 'POST /assemblies/:assemblyId/monitoring/test'
    | 'POST /assemblies/:id/duplicate'
    | 'POST /assemblies/:id/history/file-uploaded'
    | 'POST /assemblies/:id/pcb'
    | 'POST /assemblies/:id/pcb/:pcbId/download-pdf'
    | 'POST /assemblies/:id/pcb/:pcbId/offer-state'
    | 'POST /assemblies/:id/pcb/:pcbId/specification/export-csv'
    | 'POST /assemblies/:tenant/ids'
    | 'POST /assemblies/:tenant/trees'
    | 'POST /assemblies/bulk'
    | 'POST /assemblies/import'
    | 'POST /assemblies/paginated'
    | 'POST /auth/accept-invite'
    | 'POST /auth/customers/signup'
    | 'POST /bom-importer/extract-possible-parameters'
    | 'POST /bom-importer/extract-technical-parameters'
    | 'POST /bom-importer/line-builder'
    | 'POST /bom-importer/screener'
    | 'POST /bom-items/:aggregationKey/design-items/bulk-delete'
    | 'POST /calculations/calculation-assembly-costs'
    | 'POST /calculations/calculation-assembly-details'
    | 'POST /calculations/frozen-scenario-cost'
    | 'POST /calculations/templates'
    | 'POST /comments'
    | 'POST /comments/bulk'
    | 'POST /components/aggregations'
    | 'POST /components/bulk'
    | 'POST /components/custom/bulk'
    | 'POST /components/demand-tree'
    | 'POST /components/import'
    | 'POST /components/search'
    | 'POST /contributors/rfqs/:rfqId/invite'
    | 'POST /contributors/rfqs/bulk'
    | 'POST /custom-attribute-definitions/bulk'
    | 'POST /custom-attributes/:entityType/bulk'
    | 'POST /custom-part-alerts/dismiss/:alertId'
    | 'POST /custom-part-categories'
    | 'POST /custom-part-specification'
    | 'POST /custom-part-specification/:id/custom-part'
    | 'POST /custom-part-specification/:id/pcb'
    | 'POST /custom-part-specification/assemblies/bulk'
    | 'POST /custom-part-specification/bulk'
    | 'POST /customers'
    | 'POST /customers/find'
    | 'POST /dashboard/quick-actions'
    | 'POST /demand-groups'
    | 'POST /demand-groups/:id/award'
    | 'POST /demand-groups/bulk'
    | 'POST /demand-scenarios'
    | 'POST /demand/delete-bulk'
    | 'POST /demand/export-csv'
    | 'POST /demand/export-monitoring'
    | 'POST /demand/export-summary-demands'
    | 'POST /demand/export'
    | 'POST /demand/import'
    | 'POST /design-items/bom-importer'
    | 'POST /design-items/bom-importer/search'
    | 'POST /design-items/bulk'
    | 'POST /design-items/history'
    | 'POST /design-items/many'
    | 'POST /design-items/part-alternatives/bulk'
    | 'POST /email-template'
    | 'POST /ems/pcb/:assembly/versions/:version/outline'
    | 'POST /ems/pcb/materials/import'
    | 'POST /ems/pcb/pcbs/:pcbId/files'
    | 'POST /ems/pcb/v2/pcbs'
    | 'POST /expense-configurations/bulk'
    | 'POST /expenses'
    | 'POST /export/bom/templates'
    | 'POST /export/costed-bom/templates'
    | 'POST /files/ems/pcb/domatch'
    | 'POST /files/upload'
    | 'POST /flexible-calculation/evaluate'
    | 'POST /flexible-calculation/exported-variables'
    | 'POST /flexible-calculation/kv'
    | 'POST /flexible-calculation/plans'
    | 'POST /flexible-calculation/plans/from-template'
    | 'POST /flexible-calculation/plans/validate'
    | 'POST /flexible-calculation/templates'
    | 'POST /flexible-calculation/templates/convert-all-from-legacy'
    | 'POST /flexible-calculation/templates/convert-from-legacy/:id'
    | 'POST /flexible-calculation/templates/validate'
    | 'POST /formula/test'
    | 'POST /formula/validate'
    | 'POST /gateway/llm/flexible-calculation/formula/chat'
    | 'POST /gateway/llm/flexible-calculation/plans/diagnose-error'
    | 'POST /gateway/llm/flexible-calculation/templates/map-conversion'
    | 'POST /gateway/llm/off-the-shelf/offers'
    | 'POST /gateway/llm/pcb/offers'
    | 'POST /gateway/llm/pcb/specifications'
    | 'POST /gateway/llm/quotation-template/chat'
    | 'POST /gateway/llm/quotation-template/compile'
    | 'POST /gateway/llm/quotation-template/from-pdf'
    | 'POST /gateway/llm/quotation-template/validate-directives'
    | 'POST /internal-role-access'
    | 'POST /internal-roles'
    | 'POST /ipns/assemblies/bulk'
    | 'POST /ipns/bulk'
    | 'POST /ipns/find'
    | 'POST /ipns/search/generics/bulk'
    | 'POST /ipns/search/linked-parts/bulk'
    | 'POST /ipns/search/suggested-parts/bulk'
    | 'POST /llm/usage'
    | 'POST /llm/usage/check'
    | 'POST /machine-tokens'
    | 'POST /manufacturers'
    | 'POST /manufacturers/:id/aliases'
    | 'POST /manufacturers/find'
    | 'POST /manufacturers/import'
    | 'POST /manufacturing-assembly-details'
    | 'POST /manufacturing-cache/sourcing/refresh/:assemblyId'
    | 'POST /manufacturing-kv-store'
    | 'POST /manufacturing-scenario-templates'
    | 'POST /manufacturing-scenario-templates/:templateId/duplicate'
    | 'POST /manufacturing-scenarios'
    | 'POST /manufacturing-scenarios/:manufacturingScenarioId/duplicate'
    | 'POST /manufacturing-scenarios/lead-times'
    | 'POST /negotiation-v2'
    | 'POST /negotiation/line-items/part-options-with-quote-request-line-items'
    | 'POST /offer-import-contexts'
    | 'POST /offer-update'
    | 'POST /offers/bulk'
    | 'POST /offers/custom-part'
    | 'POST /offers/custom-part/:id/additional-files/duplicate'
    | 'POST /offers/custom-part/bulk'
    | 'POST /offers/custom-part/bulk/import'
    | 'POST /offers/custom-part/with-solutions'
    | 'POST /offers/delete'
    | 'POST /offers/find'
    | 'POST /offers/import'
    | 'POST /offers/off-the-shelf'
    | 'POST /offers/off-the-shelf/:id/additional-files/duplicate'
    | 'POST /offers/off-the-shelf/with-solutions'
    | 'POST /offers/pcb/:id/update'
    | 'POST /offers/v1/find'
    | 'POST /order-management/orders'
    | 'POST /order-management/orders/initialize-payment'
    | 'POST /organization-settings/checkout-conditions/replace-all'
    | 'POST /organization-settings/default-pcb-panel-preferences'
    | 'POST /organization-settings/landing-page-tiles/replace-all'
    | 'POST /organization-settings/manufacturer-preferences'
    | 'POST /organization-settings/sites'
    | 'POST /organization-settings/sites/find'
    | 'POST /panels'
    | 'POST /panels/generate'
    | 'POST /parts/availability'
    | 'POST /parts/emission-data-requests'
    | 'POST /parts/generic'
    | 'POST /parts/generic/bulk'
    | 'POST /parts/library/custom/search'
    | 'POST /parts/library/run-search-for-part'
    | 'POST /parts/library/search'
    | 'POST /parts/library/sourcing'
    | 'POST /parts/off-the-shelf'
    | 'POST /parts/off-the-shelf/alternatives/bulk'
    | 'POST /parts/off-the-shelf/assemblies/bulk'
    | 'POST /parts/off-the-shelf/bulk-update'
    | 'POST /parts/off-the-shelf/bulk'
    | 'POST /parts/off-the-shelf/find'
    | 'POST /parts/off-the-shelf/search/generic/bulk'
    | 'POST /parts/off-the-shelf/search/mpn/bulk'
    | 'POST /parts/off-the-shelf/search/mpn/many'
    | 'POST /parts/off-the-shelf/trigger-offers-update'
    | 'POST /parts/off-the-shelf/votes'
    | 'POST /pcb-approval-state/bulk'
    | 'POST /pcb-panel-preferences'
    | 'POST /pcb-pdf-specification-extraction'
    | 'POST /pcb-specification-templates'
    | 'POST /pcb/:pcbId/upload-files'
    | 'POST /pcb/panel/render'
    | 'POST /pnp/bulk/import'
    | 'POST /pnp/upload-failed-url'
    | 'POST /pnp/upload-url'
    | 'POST /price/calculation'
    | 'POST /price/calculation/:nameOrID/tables'
    | 'POST /price/calculation/:nameOrID/tables/:table'
    | 'POST /price/calculation/:nameOrID/tables/:table/versions/:version/use'
    | 'POST /price/capabilities/:supplier'
    | 'POST /price/capabilities/:supplier/tables'
    | 'POST /projects'
    | 'POST /purchase-orders/:rfqId'
    | 'POST /purchase-orders/find'
    | 'POST /purchase-orders/parametric-search-info'
    | 'POST /purchase-orders/send-test-email'
    | 'POST /quotation-templates'
    | 'POST /quotation-templates/:id/duplicate'
    | 'POST /quotation/quotationitems'
    | 'POST /quotation/quotations'
    | 'POST /quote-request/:id/add-offers'
    | 'POST /quote-request/download-attachments'
    | 'POST /quote-request/draft'
    | 'POST /quote-request/find'
    | 'POST /quote-request/line-item/delete'
    | 'POST /quote-request/line-item/update-many'
    | 'POST /quote-request/line-items'
    | 'POST /quote-request/line-items/duplicate'
    | 'POST /quote-request/negotiation-v2/:id/draft'
    | 'POST /quote-request/rfq/:rfqId/draft'
    | 'POST /quote-request/send-many'
    | 'POST /quote-request/send-reminders'
    | 'POST /quote-request/template'
    | 'POST /resources'
    | 'POST /rfqs'
    | 'POST /rfqs/:rfqId/customer-portal'
    | 'POST /rfqs/:rfqId/edit-quotation-request'
    | 'POST /rfqs/:rfqId/snapshot/trigger'
    | 'POST /rfqs/:rfqId/technical-support-request'
    | 'POST /rfqs/:rfqId/update-offers'
    | 'POST /risk-management/notifications'
    | 'POST /siliconexpert/acl'
    | 'POST /siliconexpert/quota-estimate'
    | 'POST /solutions/custom-part/bulk'
    | 'POST /sourcing-line-item/sync'
    | 'POST /sourcing-scenarios'
    | 'POST /sourcing-scenarios/:sourcingScenarioId/duplicate'
    | 'POST /sourcing-scenarios/:sourcingScenarioId/load-api-offers'
    | 'POST /sourcing-scenarios/bulk'
    | 'POST /sourcing-templates'
    | 'POST /sourcing/calculation/compare'
    | 'POST /sourcing/calculation/line-items/run-rule-based-selection'
    | 'POST /sourcing/calculation/line-items/run-selection'
    | 'POST /sourcing/calculation/read-selection'
    | 'POST /sourcing/calculation/run-selection'
    | 'POST /sourcing/calculation/summary'
    | 'POST /sourcing/export/cost-breakdown-xlsx'
    | 'POST /supplier-contacts'
    | 'POST /supplier-contacts/bulk-delete'
    | 'POST /supplier/:supplierId/terms'
    | 'POST /suppliers-and-stock-locations'
    | 'POST /suppliers-and-stock-locations/bulk-delete'
    | 'POST /suppliers-and-stock-locations/bulk'
    | 'POST /suppliers/import'
    | 'POST /suppliers/line-card-rules/import'
    | 'POST /suppliers/supplier-contacts'
    | 'POST /user-drivers'
    | 'POST /users/customers/:customerId/invites'
    | 'POST /users/organization/invites'
    | 'POST /users/organization/support-user'
    | 'POST /users/roles/bulk'
    | 'PUT /assembly/assemblies/:assembly/versions/:version/fileapproval/status'
    | 'PUT /assembly/assemblies/:assembly/versions/:version/files'
    | 'PUT /components'
    | 'PUT /dashboard/preferences'
    | 'PUT /ems/pcb/v2/pcbs/:pcb/specifications/:specification'
    | 'PUT /ems/renderer/assemblies/:assemblyId/versions/:versionId/measurements/status'
    | 'PUT /export/bom/templates/:id'
    | 'PUT /export/costed-bom/templates/:id'
    | 'PUT /pcb-specification-preferences/assemblies/:assemblyId/pcb/:pcbId'
    | 'PUT /pcb/:pcbId/files'
    | 'PUT /price/calculation/:nameOrID'
    | 'PUT /price/capabilities/:supplier'
    | 'PUT /price/capabilities/:supplier/tables/:table'
    | 'PUT /price/capabilitycheck/bypcb'
    | 'PUT /price/prices/assemblies/:assembly/versions/:version/specifications/:specification/calculate'
    | 'PUT /price/prices/assemblies/:assembly/versions/:version/specifications/:specification/panels/:panel/calculate'
    | 'PUT /price/prices/calculate'
    | 'PUT /price/prices/shares/:share/specifications/:specification/calculate'
    | 'PUT /quotation/quotationitems/:item'
    | 'PUT /quotation/quotations/:customer/quotations/:quotation/addresses/billing'
    | 'PUT /quotation/quotations/:customer/quotations/:quotation/addresses/shipping'
    | 'PUT /quotation/quotations/:customer/quotations/:quotation/items'
    | 'PUT /quotation/quotations/:idOrName'
    | 'PUT /quotation/quotations/:idOrName/status'
    | 'PUT /quotation/quotations/:quotation/items/:item/status'
    | 'PUT /rfqs/:rfqId/quotation-builder-state'
    | 'PUT /sourcing-apis/:sourcesApi/relevance';
